import React from "react";

export const juegosPublishedAt = (
  <span className="white">
    Revista <i>Vida</i> No. 32-33, 1949
  </span>
);
